import { createContext, useContext, useEffect, useState } from "react";
import { BUSSINESS_NAME } from "../appsetting";
import { jwtDecode } from "jwt-decode";

const AuthContext = createContext();
const isTokenValid = (exp) => {
    try {
      const currentTime = Date.now() / 1000; // in seconds
      return exp > currentTime;
    } catch (e) {
      return false;
    }
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    try {
      const storedToken = localStorage.getItem(BUSSINESS_NAME + "_token");
      const decodedUser = jwtDecode(storedToken);
      if (storedToken && isTokenValid(decodedUser?.exp)) {
        return decodedUser; // Save decoded token payload to state
      }else{
        localStorage.removeItem(BUSSINESS_NAME + "_token");
        return null;
      }
    } catch (error) {
      console.error("Invalid token", error);
      return null;
    }
  });

  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  const login = async (data) => {
    try {
      const decodedUser = jwtDecode(data); // Decode token
      if (data && isTokenValid(decodedUser?.exp)) {
            localStorage.setItem(BUSSINESS_NAME + "_token", data);
            setUser(decodedUser); // Save decoded user to state
      } else {
        localStorage.removeItem(BUSSINESS_NAME + "_token");
      }
    } catch (error) {
      console.error("Login failed", error);
    }
  };


  const logout = () => {
    localStorage.removeItem(BUSSINESS_NAME + "_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider
      value={{ user, login, logout, isSidebarCollapsed, setIsSidebarCollapsed }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
